<template>
  <div class="conversation-item-default">
      <p>特殊消息</p>
  </div>
</template>
<script>
  import {
    reactive,
    onMounted,
  } from 'vue'
  import {
    useRouter
  } from 'vue-router'
  // import {
  //   Toast
  // } from 'vant'
  import {
    useStore
  } from "vuex"


  export default {
    name: 'conversationitemdefault',
    props: ['item'],
    setup() {
      const store = useStore()

      const router = useRouter()
      const state = reactive({
        uid: store.state.imuid,
      })

      onMounted(() => {

      })

      // 返回
      const onClickLeft = () => {
        router.back()
      }



      return {
        state,
        onClickLeft,
      }
    }
  }
</script>
<style scoped="scoped">
  .conversation-item-default {
    padding: 20px 0;
    margin-bottom: 30px;
  }
  .conversation-item-default p{
    font-size: 24px;
    text-align: center;
    color: #999;
  }
</style>